import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppCommonModule } from '@root/common/app-common.module';
// -----COMPONENTS
import { LoginComponent } from './login/login.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ContainerComponent } from './container/container.component';
import { ComponentsRoutingModule } from './components-routing.module';
import { PushNotificationComponent } from './push-notification/push-notification.component';
import { CreateNotificationComponent } from './push-notification/create-notification/create-notification.component';
import { SendNotificationComponent } from './push-notification/send-notification/send-notification.component';
import { PushNotificationHistoryComponent } from './push-notification/push-notification-history/push-notification-history.component';
import { ReportsComponent } from './reports/reports.component';
import { UserManagmentComponent } from './user-managment/user-managment.component';
import { AddUserComponent } from './user-managment/add-user/add-user.component';
import { AddRolesComponent } from './user-managment/add-roles/add-roles.component';
import { UserListComponent } from './user-managment/add-user/user-list/user-list.component';
import { IfaListComponent } from './ifa-list/ifa-list.component';
import { InvestorListComponent } from '@investor-list/investor-list.component';
import { CreateTagDialogComponent } from './ifa-list/create-tag-dialog/create-tag-dialog.component';
import { IfaTagDialogComponent } from './ifa-list/ifa-tag-dialog/ifa-tag-dialog.component';
import { InvestorListContainerComponent } from '@investor-list/investor-list-container/investor-list-container.component';
import { IfaListContainerComponent } from './ifa-list/ifa-list-container/ifa-list-container.component';
import { IfaBlockDialogComponent } from './ifa-list/ifa-block-dialog/ifa-block-dialog.component';
import { InvestorBlockDialogComponent } from "@investor-list/investor-block-dialog/investor-block-dialog.component";
import { PasswordValidatorDirective } from '@root/components/change-password/password-validation.directive';
import { IfaConfirmationComponent } from './ifa-list/ifa-confirmation/ifa-confirmation.component';
import { RolesListComponent } from './user-managment/roles-list/roles-list.component';
import { AreaComponent } from './user-managment/area/area.component';
import { RegionComponent } from './user-managment/area/region/region.component';
import { DepartmentComponent } from './user-managment/area/department/department.component';
import { RegionListComponent } from './user-managment/area/region-list/region-list.component';
import { DepartmentListComponent } from './user-managment/area/department-list/department-list.component';
import { ResetPasswordComponent } from './user-managment/reset-password/reset-password.component';

@NgModule({
  declarations: [
    LoginComponent,
    ChangePasswordComponent,
    ContainerComponent,
    PushNotificationComponent,
    CreateNotificationComponent,
    SendNotificationComponent,
    PushNotificationHistoryComponent,
    ReportsComponent,
    UserManagmentComponent,
    AddUserComponent,
    AddRolesComponent,
    UserListComponent,
    IfaListComponent,
    InvestorListComponent,
    CreateTagDialogComponent,
    IfaTagDialogComponent,
    IfaListContainerComponent,
    InvestorListContainerComponent,
    IfaBlockDialogComponent,
    InvestorBlockDialogComponent,
    PasswordValidatorDirective,
    IfaConfirmationComponent,
    RolesListComponent,
    AreaComponent,
    RegionComponent,
    DepartmentComponent,
    RegionListComponent,
    DepartmentListComponent,
    ResetPasswordComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ComponentsRoutingModule,
    AppCommonModule,
  ],

  exports: [],
  entryComponents: [
    CreateTagDialogComponent,
    IfaTagDialogComponent,
    IfaBlockDialogComponent,
    InvestorBlockDialogComponent,
    IfaConfirmationComponent,
    ResetPasswordComponent,
  ],

  providers: [],
})
export class ComponentsModule {}
